module.exports = __webpack_public_path__ + "img/hgai.63bcebb3.jpg";